import { Options } from "src/components/atoms/inputs/FlowioSelect/types";

export const PAGING_OPTION_VALUES = [5, 10, 25, 50, 100];
export const PAGING_OPTIONS: Options = PAGING_OPTION_VALUES.map(String).map(
  (value) => ({
    value,
    name: value,
  })
);
